import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import "../styles/section-chef.css";

import PhotoExample from "../../assets/photo-example.png";
import PreviewBanner from "../../assets/preview-banner.png";
import Tips from "../../assets/tips.png";

import { useState } from "react";
import { GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { openNotificationWithIcon } from "./notification-bar";

import { Select } from "antd";

import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { uploadFile } from "../functions/upload-file";

import { useLocation } from "react-router-dom";
import { createLogger } from "../../utils/logger";

const logger = createLogger("SelectEditMenu");
const SelectEditMenu = (props) => {
  const { lang, user } = props;
  const history = useHistory();

  const [step, setStep] = useState(0);

  const [selectedCuisine, setSelectedCuisine] = useState(null);
  const [selectedSpicy, setSelectedSpicy] = useState(null);

  const [foodTypeList, setFoodTypeList] = useState([]);
  const [spicyList, setSpicyList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [allergensList, setAllergensList] = useState([]);
  const [previewPhoto, setPreviewPhoto] = useState(null);

  const [load, setLoad] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const setting = useSelector((state) => state.setting);

  // Access the query parameter values
  const selectedFoodId = searchParams.get("food-selected");

  const [detail, setDetail] = useState({
    chef_id: user?._id,
    name: "",
    // food_type: "",
    is_extra: false,
    extra_food: "",
    food_type: null,
    spice_level: null,
    portion: 1,
    cost: 0,
    description: "",
    limit: 1,
    comment: "",
    expirity: 1,
    ingredient: [],
    allergens: [],
    pic: null
  });

  const foodPicRef = useRef(null);

  useEffect(() => {
    initialData();
  }, []);

  // Synchronize selection states with detail object
  // Find the matching food_type from foodTypeList to ensure proper object reference
  useEffect(() => {
    if (detail.food_type && foodTypeList.length > 0) {
      // Find the matching food_type object from foodTypeList by _id
      const matchingFoodType = foodTypeList.find(
        (item) => item?._id === detail.food_type?._id
      );
      if (matchingFoodType) {
        setSelectedCuisine(matchingFoodType);
      } else {
        // Fallback to the original object if not found in list
        setSelectedCuisine(detail.food_type);
      }
    } else if (detail.food_type) {
      // If foodTypeList not loaded yet, set it anyway (will be updated when list loads)
      setSelectedCuisine(detail.food_type);
    }
  }, [detail.food_type, foodTypeList]);

  // Synchronize spicy level selection with detail object
  // Find the matching spice_level from spicyList to ensure proper object reference
  useEffect(() => {
    if (detail.spice_level && spicyList.length > 0) {
      // Find the matching spice_level object from spicyList by _id
      const matchingSpiceLevel = spicyList.find(
        (item) => item?._id === detail.spice_level?._id
      );
      if (matchingSpiceLevel) {
        setSelectedSpicy(matchingSpiceLevel);
      } else {
        // Fallback to the original object if not found in list
        setSelectedSpicy(detail.spice_level);
      }
    } else if (detail.spice_level) {
      // If spicyList not loaded yet, set it anyway (will be updated when list loads)
      setSelectedSpicy(detail.spice_level);
    }
  }, [detail.spice_level, spicyList]);

  // useEffect(() => {}, [live]);

  const initialData = async () => {
    try {
      setLoad(true);

      const request_details_food = {
        type: GET,
        url: service_api,
        route: `food/get-one/${selectedFoodId}`,
        data: null,
        token: user?.refresh_token
      };

      const request_details_allergens = {
        type: GET,
        url: service_api,
        route: `allergens/get-actif`,
        data: null,
        token: user?.refresh_token
      };

      const request_details_ingredient = {
        type: GET,
        url: service_api,
        route: `ingredient/get-actif`,
        data: null,
        token: user?.refresh_token
      };

      const request_details_spicy = {
        type: GET,
        url: service_api,
        route: `spicy/get-actif`,
        data: null,
        token: null
      };

      const request_details_food_type = {
        type: GET,
        url: service_api,
        route: `food-type/get-actif`,
        data: null,
        token: null
      };

      const response = await Promise.allSettled([
        MakeRequestAsync(request_details_allergens),
        MakeRequestAsync(request_details_ingredient),
        MakeRequestAsync(request_details_spicy),
        MakeRequestAsync(request_details_food_type),
        MakeRequestAsync(request_details_food)
      ]);

      response.forEach((item) => {
        if (item.status !== "fulfilled") {
          throw new Error("One or more requests failed");
        }
      });

      const [
        allergensResult,
        ingredientResult,
        spicyResult,
        foodTypeResult,
        foodResult
      ] = response;

      const decryptedAllergens = decryptSingleData(
        allergensResult.value.data.allergens
      );
      setAllergensList(decryptedAllergens);

      const decryptedIngredients = decryptSingleData(
        ingredientResult.value.data.ingredient
      );
      setIngredientList(decryptedIngredients);

      const decryptedSpicy = decryptSingleData(spicyResult.value.data.spicy);
      setSpicyList(decryptedSpicy);

      const decryptedFoodType = decryptSingleData(
        foodTypeResult.value.data.food_type
      );
      setFoodTypeList(decryptedFoodType);

      const decryptedFood = decryptSingleData(foodResult.value.data.food);
      setDetail(decryptedFood);
    } catch (err) {
      logger.log("Error in initialData: ", err?.response?.data?.message || err);
    } finally {
      setLoad(false);
    }
  };

  const updateFood = async () => {
    setStep(step + 1);
    setLoad(true);

    if (!detail.pic) {
      return openNotificationWithIcon(
        "error",
        t("validation.a_photo_is_requ_1", lang)
      );
    }
    let uploadFoodImage;
    if (previewPhoto !== null) {
      uploadFoodImage = await uploadFile(detail?.pic);

      if (!uploadFoodImage.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",

          t("select_edit_menu.error_upload_image", lang)
        );
      }
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `food/chef-update-food/${detail?._id}`,
      data: {
        ...detail,
        pic: previewPhoto === null ? detail?.pic : uploadFoodImage.data.url
      },
      token: user?.refresh_token
    };

    try {
      const res = await MakeRequestAsync(request_details);
      setTimeout(() => {
        return history.push("/chef/iam-a-chef/menu");
      }, 1000);
    } catch (err) {
      setStep(step - 1);
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  const handleButtonClick = () => {
    return foodPicRef.current.click();
  };

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];

    readFileAsUrl(selectedFile);

    return setDetail({
      ...detail,
      pic: selectedFile
    });
  };

  const readFileAsUrl = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewPhoto(reader.result);
    };
    return reader.readAsDataURL(file);
  };

  return (
    <div className="section-chef-menu-right-add-food">
      <div className="section-chef-menu-right-add-food-inside">
        <div
          style={{
            width: "100%",
            height: "85%"
          }}
        >
          {step === 0 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <input
                className="input-food-name"
                placeholder={t("common.name_your_dish_2", lang)}
                name="name"
                value={detail?.name}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    name: e.target.value
                  });
                }}
              />
            </div>
          )}
          {step === 1 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.dish_details_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.food_type_2", lang)}
              </p>
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10
                }}
              >
                {foodTypeList.map((item) => (
                  <div
                    onClick={() => {
                      setSelectedCuisine(
                        //  ? item?.eng_name : item?.name
                        item
                      );
                      return setDetail({
                        ...detail,
                        food_type: item
                        // food_type:  ? item?.eng_name : item?.name
                      });
                    }}
                    style={
                      selectedCuisine?._id === item?._id ||
                      selectedCuisine === item
                        ? // Compare by _id for object matching, or direct reference
                          {
                            backgroundColor: "#ffebf0",
                            border: "1px solid #ff114d",
                            color: "#ff114d",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                        : {
                            border: "1px solid #cecece",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                    }
                  >
                    {lang === "eng" ? item?.eng_name : item?.name}
                  </div>
                ))}
              </div>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.does_this_dish__2", lang)}{" "}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.let_the_custome_2", lang)}{" "}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: 15
                }}
              >
                <label
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 5
                  }}
                >
                  <input
                    type="radio"
                    name="side"
                    value={"yes"}
                    checked={
                      detail.is_extra === true ||
                      (detail.extra_food && detail.extra_food.trim() !== "")
                    }
                    onChange={() => {
                      setDetail({
                        ...detail,
                        is_extra: true,
                        extra_food: detail.extra_food || ""
                      });
                    }}
                  />{" "}
                  {t("select_edit_menu.yes", lang)}
                </label>
                <label
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 5
                  }}
                >
                  <input
                    type="radio"
                    name="side"
                    value={"no"}
                    checked={
                      !(
                        detail.is_extra === true ||
                        (detail.extra_food && detail.extra_food.trim() !== "")
                      )
                    }
                    onChange={() => {
                      setDetail({
                        ...detail,
                        is_extra: false,
                        extra_food: ""
                      });
                    }}
                  />{" "}
                  {t("select_edit_menu.no", lang)}
                </label>
              </div>
              {(detail?.is_extra === true ||
                (detail?.extra_food && detail.extra_food.trim() !== "")) && (
                <input
                  className="select-address-box"
                  placeholder={t("validation.please_state_th_2", lang)}
                  placeholderStyle
                  name={"extra_food"}
                  value={detail?.extra_food}
                  onChange={(e) => {
                    setDetail({
                      ...detail,
                      is_extra: true,
                      extra_food: e.target.value
                    });
                  }}
                />
              )}
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("select_edit_menu.spicy_level", lang)}
              </p>
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10
                }}
              >
                {spicyList.map((item) => (
                  <div
                    onClick={() => {
                      setSelectedSpicy(
                        //  ? item?.eng_name : item?.name
                        item
                      );
                      return setDetail({
                        ...detail,
                        spice_level: item
                        // spice_level: item?.name
                      });
                    }}
                    style={
                      selectedSpicy?._id === item?._id || selectedSpicy === item
                        ? // Compare by _id for object matching, or direct reference
                          {
                            backgroundColor: "#ffebf0",
                            border: "1px solid #ff114d",
                            color: "#ff114d",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                        : {
                            border: "1px solid #cecece",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                    }
                  >
                    {lang === "eng" ? item?.eng_name : item?.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {step === 2 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.package_price_2", lang)}
              </p>
              {/* <hr /> */}
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.package_size_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.how_many_servin_2", lang)}{" "}
              </p>
              <div
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10
                }}
              >
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.portion === 1) {
                      return;
                    }
                    setDetail({ ...detail, portion: detail.portion - 1 });
                  }}
                >
                  <AiOutlineMinusCircle size={25} />
                </div>
                <div
                  style={{
                    fontSize: 18
                  }}
                >
                  {detail?.portion}
                </div>
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.portion === 10) {
                      return;
                    }
                    setDetail({ ...detail, portion: detail.portion + 1 });
                  }}
                >
                  <AiOutlinePlusCircle size={25} />
                </div>
              </div>
              <hr
                style={{
                  marginTop: 20
                }}
              />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.price_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.we_recommend_en_1", lang)}{" "}
              </p>
              <input
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10
                }}
                type="number"
                name={"cost"}
                value={detail?.cost}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    cost: e.target.value
                  });
                }}
              />
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#ff114d",
                  marginTop: 15
                }}
              >
                {t("commerce.you_earn_by_ord_2", lang)} {"  "}
                <b>
                  {"$" + (detail?.cost - (detail?.cost * setting?.fee) / 100)}
                </b>
              </p>
            </div>
          )}
          {step === 3 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.description_ava_2", lang)}{" "}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray"
                }}
              >
                {t("select_edit_menu.description_dish", lang)}
              </p>

              <textarea
                className="select-address-box"
                rows={4}
                style={{
                  width: "100%",
                  borderRadius: 5,
                  height: "auto",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 5,
                  backgroundColor: "#f7f7f7"
                }}
                maxLength={400}
                name={"description"}
                value={detail?.description}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    description: e.target.value
                  });
                }}
              />
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: 0
                }}
              >
                {t("common.400_words_maxim_2", lang)}{" "}
              </p>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("commerce.limit_of_dishes_2", lang)}{" "}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("commerce.how_many_orders_2", lang)}{" "}
              </p>
              <input
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  backgroundColor: "#f7f7f7"
                }}
                type="number"
                name={"limit"}
                value={detail?.limit}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    limit: e.target.value
                  });
                }}
              />
            </div>
          )}
          {step === 4 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.more_informatio_1", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.reheating_instr_2", lang)}{" "}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray"
                }}
              >
                {t("common.specify_how_man_2", lang)}{" "}
              </p>
              <textarea
                className="select-address-box"
                rows={4}
                style={{
                  width: "100%",
                  borderRadius: 5,
                  height: "auto",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 5,
                  backgroundColor: "#f7f7f7"
                }}
                maxLength={300}
                name={"comment"}
                value={detail?.comment}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    comment: e.target.value
                  });
                }}
              />
              <p
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#cecece",
                  marginTop: 0
                }}
              >
                {t("common.300_words_maxim_2", lang)}{" "}
              </p>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.expiration_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.the_number_of_d_2", lang)}{" "}
              </p>
              <div
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10
                }}
              >
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.expirity === 1) {
                      return;
                    }
                    setDetail({ ...detail, expirity: detail.expirity - 1 });
                  }}
                >
                  <AiOutlineMinusCircle size={25} />
                </div>
                <div
                  style={{
                    fontSize: 18
                  }}
                >
                  {detail?.expirity}
                </div>
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.expirity === 10) {
                      return;
                    }
                    setDetail({ ...detail, expirity: detail.expirity + 1 });
                  }}
                >
                  <AiOutlinePlusCircle size={25} />
                </div>
              </div>
            </div>
          )}
          {step === 5 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.ingredients_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("validation.list_the_ingred_2", lang)}{" "}
              </p>
              <Select
                mode="multiple"
                allowClear
                style={{
                  width: "100%",
                  borderRadius: 15
                }}
                placeholder={t("common.type_and_search_4", lang)}
                value={detail?.ingredient?.map((item) => item._id) || []}
                onChange={(e) => {
                  logger.log(e);
                  const newArr = e.map((data) => {
                    return ingredientList.filter((item) => {
                      return item._id === data;
                    })[0];
                  });
                  logger.log(newArr);
                  setDetail({
                    ...detail,
                    ingredient: newArr
                  });
                }}
                options={ingredientList.map((item) => {
                  return {
                    label: lang === "eng" ? item?.eng_name : item?.name,
                    value: item._id
                  };
                })}
              />
              <div
                style={{
                  width: "100%",
                  height: 300,
                  backgroundColor: "#f7f7f7",
                  marginTop: 30,
                  borderRadius: 5
                }}
              >
                <p
                  style={{
                    gap: 10,
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    marginLeft: 20,
                    alignItems: "center"
                  }}
                >
                  <img
                    alt="tips"
                    src={Tips}
                    style={{
                      width: 20
                    }}
                  />{" "}
                  {t("common.tips_2", lang)}
                </p>
                <ul
                  style={{
                    textAlign: "left",
                    marginLeft: 10
                  }}
                >
                  <li>{t("common.specify_the_typ_3", lang)} </li>
                  <li>{t("common.seasonings_and__2", lang)} </li>
                  <li>{t("common.toppings_2", lang)}</li>
                  <li>{t("common.the_different_s_2", lang)} </li>
                  <li>{t("common.list_the_protei_2", lang)} </li>
                </ul>
              </div>
            </div>
          )}
          {step === 6 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.dietary_2", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.allergens_2", lang)}
              </p>
              <Select
                mode="multiple"
                allowClear
                style={{
                  width: "100%",
                  borderRadius: 15
                }}
                placeholder={t("common.type_and_search_5", lang)}
                value={detail?.allergens?.map((item) => item._id) || []}
                onChange={(e) => {
                  logger.log(e);
                  const newArr = e.map((data) => {
                    return allergensList.filter((item) => {
                      return item._id === data;
                    })[0];
                  });
                  logger.log(newArr);
                  setDetail({
                    ...detail,
                    allergens: newArr
                  });
                }}
                options={allergensList.map((item) => {
                  return {
                    label: lang === "eng" ? item?.eng_name : item?.name,
                    value: item._id
                  };
                })}
              />
              <div
                style={{
                  width: "100%",
                  height: 300,
                  backgroundColor: "#f7f7f7",
                  marginTop: 30,
                  borderRadius: 5
                }}
              >
                <p
                  style={{
                    gap: 10,
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    marginLeft: 20,
                    alignItems: "center"
                  }}
                >
                  <img
                    alt="tips"
                    src={Tips}
                    style={{
                      width: 20
                    }}
                  />{" "}
                  {t("select_edit_menu.tips", lang)}
                </p>
                <ul
                  style={{
                    textAlign: "left",
                    marginLeft: 10
                  }}
                >
                  <li>{t("common.specify_the_typ_4", lang)} </li>
                  <li>{t("common.a_few_example_a_2", lang)}</li>
                </ul>
              </div>
            </div>
          )}
          {step === 7 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.photo_2", lang)}
              </p>
              <ul
                style={{
                  textAlign: "left",
                  color: "#aeaeae"
                }}
              >
                <li>
                  {t(
                    "select_edit_menu.photo_guidelines.use_circular",
                    lang
                  )}{" "}
                </li>
                <li>
                  {t("select_edit_menu.photo_guidelines.take_photo", lang)}{" "}
                </li>
                <li>
                  {t(
                    "select_edit_menu.photo_guidelines.use_natural",
                    lang
                  )}{" "}
                </li>
                <li>
                  {t(
                    "select_edit_menu.photo_guidelines.capture_entire",
                    lang
                  )}{" "}
                </li>
              </ul>
              <div
                style={{
                  display: "flex"
                }}
              >
                <img
                  className="img-upload-pic"
                  src={
                    detail?.pic === null
                      ? PreviewBanner
                      : typeof detail?.pic === "string"
                        ? detail?.pic
                        : previewPhoto
                  }
                  alt="img-upload"
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: 10,
                    objectFit: "contain",
                    border: "1px solid #eeeeee"
                  }}
                  onClick={() => {
                    handleButtonClick();
                  }}
                />
                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={foodPicRef}
                  style={{
                    display: "none"
                  }}
                  onChange={(e) => handleFileSelect(e)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 15
                }}
              >
                <img
                  src={PhotoExample}
                  style={{
                    width: "100%",
                    maxWidth: 334
                  }}
                  alt="pic-example"
                />
              </div>
            </div>
          )}
          {step === 8 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 30,
                  fontWeight: 600,
                  textAlign: "center",
                  color: "#000"
                }}
              >
                {t("validation.please_wait_2", lang)}
              </p>
              <CircularProgress size={50} />
            </div>
          )}
        </div>
        <div
          style={{
            width: "100%"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
              <div
                style={{
                  width: "11.5%",
                  height: 10,
                  borderRadius: 10,
                  backgroundColor: "#d9d9d9"
                }}
                onClick={() => {
                  // setStep(item + 1);
                }}
              >
                <div
                  style={{
                    width: step > item ? "100%" : "0%",
                    height: 10,
                    borderRadius: 10,
                    backgroundColor: "#ff114d",
                    transition: "width 0.3s ease"
                  }}
                ></div>
              </div>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#cecece",
                width: 120,
                color: "#000",
                fontSize: 15,
                fontWeight: 600
              }}
              onClick={() => {
                if (load) {
                  return;
                }
                if (step === 0) {
                  return;
                }
                return setStep(step - 1);
              }}
            >
              {!load && t("common.back_2", lang)}
              {load && <CircularProgress size={25} />}
            </div>
            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#ff114d",
                width: 120
              }}
              onClick={() => {
                if (load) {
                  return;
                }
                if (step === 0) {
                  if (detail?.name?.length < 4) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.give_a_dish_nam_1", lang)
                    );
                  }
                  return setStep(step + 1);
                }
                if (step === 1) {
                  if (detail?.food_type?.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.select_food_type", lang)
                    );
                  }
                  if (detail?.spice_level?.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.select_spice", lang)
                    );
                  }

                  if (
                    detail?.is_extra === true &&
                    detail?.extra_food.length < 4
                  ) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.write_side", lang)
                    );
                  }
                  return setStep(step + 1);
                }
                if (step === 2) {
                  if (detail.cost < 5) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.price_minimum", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 3) {
                  if (detail.description.length < 30) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.description_minimum", lang)
                    );
                  }
                  if (detail.limit < 1 || detail.limit > 28) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.limit_range", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 4) {
                  return setStep(step + 1);
                }

                if (step === 5) {
                  if (detail?.ingredient.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.select_ingredients", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 6) {
                  if (detail?.allergens.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.select_allergens", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 7) {
                  if (detail?.pic === null) {
                    return openNotificationWithIcon(
                      "error",
                      t("select_edit_menu.validation.add_photo", lang)
                    );
                  }
                  return updateFood();
                }
              }}
            >
              {!load && t("common.next_2", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectEditMenu;
